import { Mongo } from 'meteor/mongo';
import {
  PAYMENT_STATUSES,
  PaymentAttemptItemsCollection,
  PaymentAttemptsCollection,
  ProviderConfigsCollection,
  calculatePaymentQuote,
} from './payments';

export const InvoicesCollection = new Mongo.Collection('invoices');
export const HourBitsCollection = new Mongo.Collection('hourBits');
export const InvoiceContributionSummariesCollection = new Mongo.Collection(
  'invoiceContributionSummaries',
);
// Server-computed and client-only, like the per-hour-bit summaries above: one
// document per ledger, carrying the aggregates APP_STYLE §6.2 and §6.6 ask for.
// Nothing is ever written to this collection on the server side.
export const InvoiceLedgerAggregatesCollection = new Mongo.Collection(
  'invoiceLedgerAggregates',
);

export {
  PAYMENT_STATUSES,
  PaymentAttemptItemsCollection,
  PaymentAttemptsCollection,
  ProviderConfigsCollection,
  calculatePaymentQuote,
};

export const INVOICE_STATUSES = {
  DRAFT: 'draft',
  ISSUED: 'issued',
  VOID: 'void',
};

export function isInvoicePayable(invoice) {
  return invoice?.status === INVOICE_STATUSES.ISSUED;
}

export function isInvoiceActive(invoice) {
  return isInvoicePayable(invoice) && !invoice.archivedAt;
}

export function minorToMoney(valueMinor, currency = 'CAD') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(valueMinor / 100);
}

export function dollarsToMinor(value) {
  return Math.round(Number(value || 0) * 100);
}

export function contributionRatesForBit(bit, attempts, attemptItems) {
  const relevantItems = attemptItems.filter((item) => item.hourBitId === bit._id);
  const attemptById = new Map(attempts.map((attempt) => [attempt._id, attempt]));

  return relevantItems.reduce(
    (rates, item) => {
      const attempt = attemptById.get(item.attemptId);
      if (!attempt || !item.hours) return rates;

      if (attempt.status === PAYMENT_STATUSES.PAID) {
        rates.paidMinor += Math.round(item.subtotalMinor / item.hours);
      }

      if (
        attempt.status === PAYMENT_STATUSES.PENDING_NEXT_STEP ||
        attempt.status === PAYMENT_STATUSES.PENDING_CONFIRMATION
      ) {
        rates.pendingMinor += Math.round(item.subtotalMinor / item.hours);
      }

      return rates;
    },
    { pendingMinor: 0, paidMinor: 0 },
  );
}
